import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";
import { Brands } from "@App/Pages/Common/Brands";

/**
 * The funnel for the general catch-all "appointment" service.
 *
 * @constructor
 */
export const Wheelchange: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("readerwechsel");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Räderwechsel"}
            step={0}
            maxSteps={1}
            onSubmit={() => navigateWithQuery(`ort`)}
          />
        }
      />
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Räderwechsel"}
            subheadline={"Wo suchst du eine Werkstatt?"}
            step={1}
            maxSteps={1}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
    </Routes>
  );
};
